import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import * as authReducer from "../../containers/Auth/auth.reducer";
import { Grid, Divider, Icon, Input, Button, Modal } from "semantic-ui-react";
import AddressDetails from "../AddressDetails";
import Loader from "../Loader";
import CreditInformation from "../CreditInformation";
import { showSuccessToast } from "../../utils/toastUtils";
import "./accountDetails.css";
import ManageAddress from "../../containers/ManageAddress";
import { apiGetAddresses } from "../../containers/ManageAddress/deliveryAddress.api";

function AccountDetails(props) {
  const [loading, setLoading] = useState(true);
  const [editMargin, setEditMargin] = useState(false);
  const [pricePercent, setPricePercent] = useState(0);
  const [openManageAddress, setOpenManageAddress] = useState(false);
  const [deliveryAddresses, setDeliveryAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState({});
  const [deliveryAddressList, setDeliveryAddressList] = useState([]);

  const {
    auth,
    actionSetEditAccountFlag,
    actionSetProfileInfoForm,
    actionSetEditProfileFlag,
    actionUpdatePriceMargin,
    actionGetProfileData,
    history,
  } = props;

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      // await props.actionGetAccountDetails();
      const { priceMargin: initialPriceMargin } = auth.accountInfo;
      if (initialPriceMargin) {
        setPricePercent(initialPriceMargin);
      }
      await getAddresses();
      setLoading(false);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, []); // Depend on accountInfo to re-run if it changes

  const changeAddressHandler = async (address) => {
    setSelectedAddress(address);

    let _deliveryAddress = [];
    if (deliveryAddresses?.length > 0) {
      await deliveryAddresses?.forEach((item) => {
        _deliveryAddress?.push({
          name: item.addressDetails.name,
          street: item.addressDetails.street,
          street2: item.addressDetails.street2,
          state: item.addressDetails.state,
          suburb: item.addressDetails.suburb,
          zip: item.addressDetails.zipCode,
          country: { name: item.addressDetails.country },
          city: item.addressDetails.city,
          isPrimary: item.isDefault,
          salesforceId: null,
          id: item.id,
          addressDistance: item.addressDetails.addressDistance,
        });
      });
    }
    await setDeliveryAddressList(_deliveryAddress);
  };

  const cancelEdit = () => {
    actionSetEditAccountFlag(false);
  };

  const updateState = (data) => {
    if (data.pricePercent !== undefined) {
      setPricePercent(data.pricePercent);
    }
    if (data.editMargin !== undefined) {
      setEditMargin(data.editMargin);
    }
    if (data.loading !== undefined) {
      setLoading(data.loading);
    }
    // Add other state updates as needed
  };

  const cancelProfileEdit = () => {
    unSetForm();
    actionSetEditProfileFlag(false);
  };

  const setForm = () => {
    const { user } = auth;
    const formData = getFormData(user); // Assuming getFormData is available in scope
    actionSetProfileInfoForm(formData);
  };

  const unSetForm = () => {
    const data = getFormData(); // Assuming getFormData is available in scope
    actionSetProfileInfoForm(data);
  };

  const boaCreditHandler = (e) => {
    e.preventDefault();
    history.push("/profile/creditApplicationForm");
  };

  const getAddresses = async () => {
    const result = await apiGetAddresses();
    if (result) {
      setDeliveryAddresses(result.deliveryAddresses);
      let _deliveryAddress = [];
      if (result.deliveryAddresses?.length > 0) {
        result.deliveryAddresses?.forEach((item) => {
          _deliveryAddress?.push({
            name: item.addressDetails.name,
            street: item.addressDetails.street,
            street2: item.addressDetails.street2,
            state: item.addressDetails.state,
            suburb: item.addressDetails.suburb,
            zip: item.addressDetails.zipCode,
            country: { name: item.addressDetails.country },
            city: item.addressDetails.city,
            isPrimary: item.isDefault,
            salesforceId: null,
            id: item.id,
            addressDistance: item.addressDetails.addressDistance,
          });
        });
      }
      setDeliveryAddressList(_deliveryAddress);
    }
  };

  const getDeliveryAddress = (deliveryAddress) => {
    if (_.isEmpty(deliveryAddress)) return null;
    return deliveryAddress.map((value, key) => {
      return (
        <Grid.Column
          width={4}
          computer={5}
          mobile={16}
          className="address-column"
          key={key}
        >
          <AddressDetails index={key} address={value} options={false} />
        </Grid.Column>
      );
    });
  };

  const editAddress = (e) => {
    e.preventDefault();
    history.push("/profile/deliveryAddress");
  };

  const changePricePercent = (e, { value }) => {
    setPricePercent(value);
  };

  const savePriceMargin = async () => {
    const data_to_update = {
      priceMargin: pricePercent,
    };
    await actionUpdatePriceMargin(data_to_update);
    showSuccessToast("Updated Inventory sell price margin.");
    setEditMargin(false);
    actionGetProfileData();
    // componentWillMount equivalent is handled by the useEffect
  };

  const editMarginPrice = (e) => {
    e.preventDefault();
    setEditMargin(true);
  };

  const {
    name,
    creditLimit,
    cafStatus,
    cafSubmitted,
    priceMargin: accountPriceMargin,
    company,
    street,
    street2,
    state,
    suburb,
    zip,
    country,
    city = "",
    contactsAndAddresses,
    parent,
    defaultContactAddressId,
  } = auth.accountInfo;
  const { pricePercent: localPricePercent, editMargin: localEditMargin } =
    useState(accountPriceMargin || 0); // Initialize local state from prop

  const postalAddress = {
    placeName: street,
    street: street2,
    state: state && state.name,
    suburb: suburb,
    postalCode: zip,
    country: country && country.name,
    city: city,
  };

  const { customerType, account = {} } = props.user;
  const { showFacilities } = account;

  let show = customerType === "enterprise" || customerType === "retail";
  if (typeof customerType === "undefined") show = true;

  const companyName = (
    <span>
      <label className="account-field-key">Company name</label>
      <p>{parent && parent.name}</p>
    </span>
  );

  const billingAddress = (
    <span>
      <label className="account-field-key">Billing address</label>
      <AddressDetails address={postalAddress} />
    </span>
  );
  const creditPopup = <CreditInformation />;

  const BOACredit = (
    <span>
      <label className="account-field-key">
        <span>
          {" "}
          Credit limit {!creditLimit && !cafSubmitted && creditPopup}{" "}
        </span>
      </label>
      {creditLimit !== 0 && <div>{creditLimit}</div>}
      {!creditLimit && !cafSubmitted && (
        <div>
          <a className="apply-boa-credit" onClick={boaCreditHandler}>
            <Icon name="wordpress forms" />
            Apply for BOA Credit
          </a>
        </div>
      )}
      {cafSubmitted && !cafStatus && (
        <div className="boa-credit-status">
          <Icon loading name="sync " />
          Credit application Status is pending
        </div>
      )}
    </span>
  );

  const deliveryAddressDetail = (
    <div>
      <Modal
        onClose={() => setOpenManageAddress(false)}
        onOpen={() => setOpenManageAddress(true)}
        open={openManageAddress}
        className="manage-address-modal "
        closeOnDimmerClick={false}
      >
        <Modal.Content>
          <ManageAddress
            allAddress={deliveryAddresses}
            onCloseManageAddress={() => setOpenManageAddress(false)}
            changeAddressHandler={changeAddressHandler}
            isDelivery={true}
            getAddresses={getAddresses}
          />
        </Modal.Content>
      </Modal>
      <label className="account-field-key">Delivery address </label>
      <a
        onClick={() => setOpenManageAddress(true)}
        className="linkToPage"
        style={{ marginLeft: -40 }}
      >
        Manage Delivery Address
      </a>
    </div>
  );

  const manageMarginPrice = (
    <div>
      {editMargin ? (
        <div>
          <Input
            type="number"
            size="small"
            min={0}
            placeholder="Quantity"
            onChange={changePricePercent}
            value={pricePercent}
          />
          <Button
            icon="save"
            size="small"
            basic
            onClick={savePriceMargin}
            style={{
              backgroundColor: "#66cc23",
              color: "#fff",
            }}
          />
          <Button
            icon="delete"
            size="small"
            basic
            onClick={() => setEditMargin(false)}
            color="red"
          />
        </div>
      ) : (
        <div>
          {accountPriceMargin !== null && accountPriceMargin !== undefined ? (
            <p>{accountPriceMargin} %</p>
          ) : (
            <em> Margin not configured yet </em>
          )}
        </div>
      )}
    </div>
  );

  return (
    <div className="account-details">
      <h3>Account information</h3>
      <Divider />
      {loading && <Loader text="Please wait" />}
      <Grid>
        {show && (
          <React.Fragment>
            <Grid.Column width={8} computer={8} mobile={16}>
              {companyName}
            </Grid.Column>

            <Grid.Column width={8} computer={8} mobile={16}>
              {billingAddress}
            </Grid.Column>
            {/* <Grid.Column width={8} computer={8} mobile={16}>
              {BOACredit}
            </Grid.Column>
            <Grid.Column width={8} computer={8} mobile={16}>
              {showFacilities ? (
                <div>
                  <label className="account-field-key">
                    Inventory price margin
                  </label>
                  <Popup
                    trigger={<Icon name="question" color="blue" />}
                    content="Inventory price margin is the margin you would like to make on top of your cost when on-selling inventory"
                    basic
                  />
                  <a onClick={editMarginPrice} className="linkToPage">
                    Change
                  </a>
                  {manageMarginPrice}
                </div>
              ) : null}
            </Grid.Column> */}
          </React.Fragment>
        )}
        <Grid.Column width={16} computer={8} mobile={16}>
          {deliveryAddressDetail}
        </Grid.Column>
      </Grid>
      <Grid columns="equal" className="address-grid">
        {getDeliveryAddress(deliveryAddressList)}
      </Grid>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.auth.user,
    editAccountFlag: state.auth.editAccountFlag,
  };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(authReducer, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AccountDetails)
);
